import { Button, Modal, Alert } from 'react-bootstrap';
import React from "react";
import { Field, reduxForm, FormSection } from 'redux-form';
import { connect } from 'react-redux';

import { ReadonlyInput, WideField, SimpleField } from '../common/Inputs';
import DateTimeField from '../common/DateTimeField';
import { PhoneInput } from '../common/PhoneInput';

import { fetchAddresses as fetchAddressesAction } from '../../actions/addresses';

import * as fetchingState from '../../constants/fetchingState';
import {
    fetchCustomerIsBusy as fetchCustomerIsBusyAction,
    resetPassword as resetPasswordAction,
    clearResetPassword as clearResetPasswordAction
} from '../../actions/customers'
import { parsePhoneNumber, validate as validatePhone, required as phoneRequired, formatPhone } from '../../extensions/phoneHelper';
import { AddressEdit } from '../common/AddressEdit';
import ConfirmModal from '../common/ConfirmModal';


const validate = ({ Phone, AddressError }) => {
    const error = {};
    const phoneError = phoneRequired(Phone) || validatePhone(Phone);
    if (phoneError)
        error.Phone = phoneError;
    if (AddressError) {
        error.Addresses = [{Address: AddressError}];
    }
    return error;
}
const asyncValidate = ({ Phone }, dispatch) => {
    const error = { Phone: "*Номер телефона уже занят." };
    const parsedPhone = parsePhoneNumber(Phone);
    return dispatch(fetchCustomerIsBusyAction(parsedPhone, error));
}

let CustomerModal = class extends React.Component {
    constructor(props) {
        super(props);
        this._handleSubmit = this._handleSubmit.bind(this);
        this.state = {
            yesNoModalShown: false
        };
        this._confirmModalClose = this._confirmModalClose.bind(this);
        this._showConfirmModal = this._showConfirmModal.bind(this);
        this._resetPassword = this._resetPassword.bind(this);
    }

    _handleSubmit(values) {
        values.IsActive = values.User.IsActive;
        if (this.props.isNew)
            values.Phone = parsePhoneNumber(values.Phone);
        this.props.onSubmit(values);
    }

    _confirmModalClose() {
        this.setState({
            yesNoModalShown: false
        });
        this.props.clearResetPasswordAction();
    }

    _showConfirmModal() {
        this.setState({
            yesNoModalShown: true
        });
    }

    _resetPassword() {
        this.props.resetPasswordAction({ phone: this.props.initialValues.Phone });
    }

    _clearResetPassword() {
        this.props.clearResetPasswordAction();
    }

    render() {
        const { fetching, initialValues: customer, crudError, onClose, handleSubmit, isNew, resetPasswordFetching, change, fetchAddressesAction, fetchedAddresses } = this.props;
        const { yesNoModalShown } = this.state;
        const formVisible = fetching === fetchingState.INITIAL;
        const closeButtonVisible = fetching === fetchingState.FETCHED || fetching === fetchingState.FAILED;

        return (
            <div>
                {!isNew && <ConfirmModal
                    onYes={this._resetPassword}
                    onNo={this._confirmModalClose}
                    fetching={resetPasswordFetching}
                    message='Сбросить пароль?'
                    title={`Телефон ${formatPhone(customer.Phone)}`}
                    show={yesNoModalShown} />}
                <Modal show={!yesNoModalShown}  >
                    <Modal.Header>
                        <Modal.Title>
                            {isNew ? 'Новая пользователь' : 'Редактирование пользователя'}
                            {!isNew && formVisible &&
                                <Button bsStyle='primary' onClick={this._showConfirmModal} style={{ float: 'right' }}>Отправить новый пароль</Button>}
                        </Modal.Title>

                    </Modal.Header>
                    <Modal.Body>
                        {formVisible && <form className='form-horizontal' onSubmit={handleSubmit(this._handleSubmit)}>
                            {!isNew && <ReadonlyInput value={customer.Id} label='Id' />}
                            {!isNew ?
                                <ReadonlyInput value={formatPhone(customer.Phone)} label='Телефон' /> :
                                <Field name='Phone' component={PhoneInput} label='Телефон' />}
                            <Field name='Name' component={SimpleField} label='Имя' />
                            <Field name='Email' component={SimpleField} label='Email' />
                            <Field name='DateOfBirth' component={DateTimeField} dateTimeFormat='DD-MM-YYYY' time={false} label='День рождения' defaultValue={isNew ? null : new Date()} />
                            <FormSection name='Address'>
                                <AddressEdit geoAddressName='Address.GeoAddress' change={change} fetchAddressesAction={fetchAddressesAction} fetchedAddresses={fetchedAddresses} />
                            </FormSection>
                            <Field name='User.IsActive' component={WideField} label='Активен' type='checkbox' />
                        </form>}
                        {fetching === fetchingState.FETCHING &&
                            <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                        {fetching === fetchingState.FETCHED &&
                            <Alert bsStyle='success'>УСПЕХ!</Alert>}
                        {fetching === fetchingState.FAILED &&
                            <Alert bsStyle='danger'>
                                <p>ОШИБКА!</p>
                                {crudError && <p>{crudError}</p>}
                            </Alert>}
                    </Modal.Body>
                    {formVisible && <Modal.Footer>
                        <Button bsStyle="success" type="submit" onClick={handleSubmit(this._handleSubmit)}>Сохранить</Button>
                        <Button type="button" onClick={onClose}>Отмена</Button>
                    </Modal.Footer>}
                    {closeButtonVisible &&
                        <Modal.Footer>
                            <Button type="button" onClick={onClose}>
                                Закрыть
                            </Button>
                        </Modal.Footer>}
                </Modal>
            </div>
        );
    }
}

let CreateModal = reduxForm({
    form: 'customerCreate',
    validate,
    asyncValidate,
    asyncBlurFields: ['Phone'],
    initialValues: {
        User: {
            IsActive: true
        },
        Addresses: [
            {}
        ]
    }
})(CustomerModal);

let EditModal = reduxForm({
    form: 'customerEdit',
    validate
})(CustomerModal);

EditModal = connect(state => ({
    resetPasswordFetching: state.application.get('customer').resetPasswordFetching,
    fetchedAddresses: state.application.get('addresses'),
    crudError: state.application.get('customer').crudError
}), { resetPasswordAction, clearResetPasswordAction, fetchAddressesAction })(EditModal);

CreateModal = connect(state => ({
    fetchedAddresses: state.application.get('addresses'),
    crudError: state.application.get('customer').crudError
}), { fetchAddressesAction })(CreateModal);


export default (props) => props.isNew ?
    <CreateModal {...props} /> :
    <EditModal {...props} />;


// WEBPACK FOOTER //
// ./src/components/customers/EditModal.jsx